var navbar = document.getElementById('quick-links');

if (navbar) {
    var sticky = navbar.offsetTop;
    // window.onscroll = function() {quickLinksScroll()};
    window.addEventListener('scroll', quickLinksScroll);
}

function quickLinksScroll() {
    console.log('sticky = ' + sticky);
    if ((window.pageYOffset + 50) >= sticky) {
        navbar.classList.add("sticky")
        navbar.nextElementSibling.classList.add('quick-links-enabled');
    } else {
        navbar.classList.remove("sticky");
        navbar.nextElementSibling.classList.remove('quick-links-enabled');
    }
}


var tabContainer = document.getElementsByClassName('quick_links_tabs');

if (tabContainer.length !== 0) {
    var tabs = tabContainer[0].getElementsByTagName('li');

    for (var i = 0; i < tabs.length; i++) {

        Array.prototype.forEach.call(tabs[i].children, child => {
            child.addEventListener('click', function() {
                for (var i = 0; i < tabs.length; i++) {
                    tabs[i].classList.remove('active');
                }
                child.closest('li').classList.add('active');

                navbar.nextElementSibling.classList.add('quick-links-enabled');

                    event.preventDefault();

                    var hash = this.hash;

                    $('html, body').animate({
                        scrollTop: $(hash).offset().top - 184
                    }, 0, function() {
                        window.location.hash = hash;
                    })
                }
            )

            var childID = $(child).attr('href');

            if ($(childID).length) {
                var childIDTop = $(childID).offset().top;
            }

            $(document).scroll(function() {
                var scrollPos = $(document).scrollTop();
                if (scrollPos + 200 > childIDTop) {
                    for (var i = 0; i < tabs.length; i++) {
                        tabs[i].classList.remove('active');
                    }
                    child.closest('li').classList.add('active');
                }
              });
          });
    }
}
